export default __webpack_public_path__ + "static/media/globalCard3.ec8f5684.webp";